import { useTranslation } from 'react-i18next';

interface LanguageSwitchProps {
  compact?: boolean;
}

export default function LanguageSwitch({ compact = false }: LanguageSwitchProps) {
  const { i18n, t } = useTranslation();
  const activeLanguage = i18n.resolvedLanguage?.startsWith('en') ? 'en' : 'pt';

  return (
    <div className={`inline-flex items-center rounded-full border border-white/20 bg-white/5 ${compact ? 'gap-0.5 p-0.5' : 'gap-1 p-1'}`}>
      {(['pt', 'en'] as const).map((lang) => {
        const isActive = activeLanguage === lang;

        return (
          <button
            key={lang}
            type="button"
            onClick={() => {
              void i18n.changeLanguage(lang);
            }}
            className={`rounded-full font-semibold transition-all ${
              compact ? 'min-w-[30px] px-1.5 py-0.5 text-[10px]' : 'min-w-[42px] px-2.5 py-1 text-xs'
            } ${
              isActive
                ? 'bg-[#C9A84C] text-[#0A1628]'
                : 'text-white hover:bg-white/10'
            }`}
            aria-label={lang === 'pt' ? 'Português' : 'English'}
          >
            {t(`language.${lang}`)}
          </button>
        );
      })}
    </div>
  );
}
